export const SEND_SELECTION = 'SEND_SELECTION';
export type SEND_SELECTION = typeof SEND_SELECTION;

export const SEND_SELECTION_UNDO = 'SEND_SELECTION_UNDO';
export type SEND_SELECTION_UNDO = typeof SEND_SELECTION_UNDO;

export const SEND_SELECTION_REDO = 'SEND_SELECTION_REDO';
export type SEND_SELECTION_REDO = typeof SEND_SELECTION_REDO;